import { Temporal, toTemporalInstant } from '@js-temporal/polyfill'

// `Temporal` is typed natively by the TypeScript lib (lib.esnext.temporal) but not yet implemented
// at runtime in every engine (Safari/Firefox ship it; Chrome is rolling out — see caniuse.com/temporal).
// This polyfill operates as a runtime global so app code can use the standard `Temporal` API directly.
//
// The polyfill's own type defs diverge cosmetically from the lib's native Temporal types, so the
// install goes through `unknown`: this is purely a runtime shim, and the lib types describe usage
// everywhere else.
//
// [OS-459] Once support is universal, delete this module, the three side-effect
// imports of it, and the @js-temporal/polyfill dependency — the lib types already assume the global.
const runtime = globalThis as unknown as {
  Temporal?: unknown
  Date: { prototype: { toTemporalInstant?: unknown } }
}

if (runtime.Temporal === undefined) {
  runtime.Temporal = Temporal
  // The standard Date -> Temporal.Instant bridge, for the rare legacy boundary that still hands out
  // a `Date`. Everyday code builds Temporal values from ISO strings instead.
  runtime.Date.prototype.toTemporalInstant = toTemporalInstant
}
